import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      title: "Upload Your Images",
      description: "Drag & drop multiple images or click to browse. Supports high-resolution JPG, PNG, WEBP formats up to 8K.",
      icon: "📤"
    },
    {
      id: 2,
      title: "AI-Powered Processing",
      description: "Our advanced deep learning model instantly analyzes and removes backgrounds with pixel-perfect precision, all processed locally on your device.",
      icon: "🤖"
    },
    {
      id: 3,
      title: "Export & Customize",
      description: "Download your images with transparent backgrounds in your preferred format. Add custom backgrounds or make fine-tuned adjustments as needed.",
      icon: "⬇️"
    }
  ];

  return (
    <section id="how-it-works" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
            Simple Yet Powerful Workflow
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Professional background removal in three easy steps, powered by enterprise-grade AI technology
          </p>
        </div>

        <div className="mt-16">
          <div className="relative">
            {/* Connection Line */}
            <div className="hidden md:block absolute top-1/2 w-full h-1 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-100 -translate-y-1/2" />

            <div className="relative grid gap-8 md:grid-cols-3">
              {steps.map((step, index) => (
                <div
                  key={step.id}
                  className="relative bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 text-blue-600 rounded-full mb-6 transform transition-transform duration-300 hover:scale-110 group-hover:rotate-12">
                    <span className="text-3xl" role="img" aria-label={step.title}>{step.icon}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {step.title}
                  </h3>
                  <p className="text-gray-600">
                    {step.description}
                  </p>
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 text-blue-400">
                      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;